import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { DoctorConnectPatient } from "../../../utils/requests/doctors";
import { QRCode, Spin, Result } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import Logo from "../../../assets/media/logo/Logo_horizontal.svg";

const AuthByDoctor = () => {
  const { uid } = useParams();
  const [token, setToken] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    DoctorConnectPatient({ patient_uid: uid })
      .then((response) => {
        const { jwt } = response.data;
        setToken(jwt);
        setLoading(false);
      })
      .catch((err) => {
        setError(err?.response?.data?.error?.message || "Une erreur est survenue");
        setLoading(false);
      });
  }, [uid]);

  console.log("Token:", `${window.location.origin}/scan-auth/${token}`);

  if (loading) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50">
        <Spin indicator={<LoadingOutlined style={{ fontSize: 48 }} spin />} />
        <p className="mt-4 text-gray-600">Génération du QR Code en cours...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <Result
          status="error"
          title="Erreur"
          subTitle={error}
        />
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 p-4">
      <div className="bg-white rounded-2xl shadow-lg p-8 max-w-md w-full text-center">
        <img src={Logo} alt="Logo" className="h-12 mx-auto mb-6" />

        <h1 className="text-2xl font-bold text-gray-800 mb-2">
          Scannez ce QR Code
        </h1>
        <p className="text-gray-600 mb-6">
          Utilisez la tablette pour scanner ce QR Code et vous connecter à votre espace patient.
        </p>

        {token && (
          <div className="flex justify-center mb-6">
            <QRCode
              value={`${window.location.origin}/scan-auth/${token}`}
              size={250}
              errorLevel="H"
              // icon={Logo}
              iconSize={40}
            />
          </div>
        )}

        <p className="text-sm text-gray-500">
          Ce QR Code est valide pour une seule connexion.
        </p>
      </div>
    </div>
  );
};

export default AuthByDoctor;
